/// <reference path="../../app.ts" />
var that;
namespace Cfnc {
    "use strict";

    interface ICfncSelectAddressModalScope extends ng.IScope {
        model: Array<any>;
        selectedAddress: Array<ICfncAddressResult>;
        ok: () => void;
        confirmOk: () => void;
        confirmCancel: () => void;
        addressChanged: (string, boolean) => void;
        errorMessages: any;
        askToConfirm: any;
        showConfirm: boolean;
        selectAddressResults: Array<any>;
        ncCounties: Array<IAddressListItem>;
    }

    interface ICfncSelectAddressModal {
        
    }

    export interface ICfncSelectAddressModel {
        addressResults: Array<ICfncAddressResult>;
        errorCodes: any;
    }

    export class CfncSelectAddressModel implements ICfncSelectAddressModal {
        addressResults: Array<ICfncAddressResult>;
        errorCodes: any;
    }

   export interface ICfncAddressResult {
        key: string;
        addresses: Array<IAddress>;
        original: IAddress;
        userOverride: boolean;
        selectedIndex?: number;
    }
    
    export interface IErrorCode {
        key: string;
        codes: Array<string>;
   }

    class Address implements IAddress {
        addressType: string;
        firstName: string;
        lastName: string;
        street: string;
        street2: string;
        city: string;
        state: string;
        postalCode: string;
        country: string;
        county: string;
        isVerified: boolean;
        resultCodes: string;
        userOverride: boolean;
        signature: string;
        key: string;
    }

    class VerifyAddressResults {
        firstName: string;
        lastName: string;
        action: string;
        providedAddressHasErrors: boolean;
        selectedIndex: number;
        key: string;
        providedAddress: Address;
        suggestedAddress: Address;
        
    }

    class CfncSelectAddressModal implements ICfncSelectAddressModal {
        static controllerId: string = "cfncSelectAddressModal";
        private log;
        
        constructor(private $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance,
            private common: ICommonFactory,
            private $scope: ICfncSelectAddressModalScope,
            private model: Array<VerifyAddressResults>,
            private addressService: IAddressService) {
            $scope.model = model;
            $scope.errorMessages = this.createErrorMessages();
            $scope.ok = this.ok;
            $scope.addressChanged = this.addressChanged;
            $scope.askToConfirm = {};
            $scope.showConfirm = false;
            $scope.confirmOk = this.confirmOk;
            $scope.confirmCancel = this.confirmCancel;
            this.$scope.selectAddressResults = new Array<Address>();
            this.$scope.ncCounties = this.addressService.ncCountyList;
        }

        ok = () => {
            var dismiss = false;
            var annoy = false;
            this.model.forEach((result) => {
                if (result.selectedIndex == 0) {
                    
                    annoy = true;

                    this.$scope.selectAddressResults.push({
                        key: result.key,
                        street: result.providedAddress.street,
                        street2: null,
                        city: result.providedAddress.city,
                        state: result.providedAddress.state,
                        postalCode: result.providedAddress.postalCode,
                        country: result.providedAddress.country,
                        county: result.providedAddress.county,
                        resultCodes: result.providedAddress.resultCodes,
                        signature: result.providedAddress.signature,
                        addressType: result.providedAddress.addressType,
                        userOverride: true,
                        isVerified: false
                    });
                }
                else if (result.selectedIndex == -1) {
                    dismiss = true;
                }
                else {
                    this.$scope.selectAddressResults.push({
                        key: result.key,
                        street: result.suggestedAddress.street,
                        street2: null,
                        city: result.suggestedAddress.city,
                        state: result.suggestedAddress.state,
                        postalCode: result.suggestedAddress.postalCode,
                        country: result.suggestedAddress.country,
                        county: result.suggestedAddress.county,
                        resultCodes: result.suggestedAddress.resultCodes,
                        signature: result.suggestedAddress.signature,
                        addressType: result.suggestedAddress.addressType,
                        userOverride: false,
                        isVerified: true
                    });
                }

            });

            if (!dismiss && !annoy) {
                this.$uibModalInstance.close(this.$scope.selectAddressResults);
            }
            else if (!dismiss && annoy) {
                this.$scope.showConfirm = true;
            }
            else {
                this.$uibModalInstance.dismiss(this.$scope.selectAddressResults);
            }
        };

        confirmOk = () => {
            this.$uibModalInstance.close(this.$scope.selectAddressResults);
        };

        confirmCancel = () => {
            this.$scope.showConfirm = false;
        };

        addressChanged = (key: string, askToConfirm: boolean) => {
            this.$scope.askToConfirm[key] = askToConfirm;           
            
        };

        createErrorMessages = () => {

            var key = this.model[0].key;
            var postalCode = this.model[0].providedAddress.country == "US" ? "ZIP" : "postal";
            var state = this.model[0].providedAddress.country == "US" ? "state" : "province";
            
            return {
                AC01: "The " + postalCode + " code has been changed.",
                AC02: "The " + state + " has been changed.",
                AC03: "The city name has been changed.",
                AC04: "The address has been found to be an alternate address and has been changed to the preferred version.",
                AC05: "The abbreviation provided for the street name has been changed to the preferred version.",
                AC10: "The street name has been changed.",
                AC11: "The street type (e.g., St, Rd) has been changed.",
                AC12: "The street direction (e.g., N, E, SW) has been changed.",
                AC13: "The suite/apartment type has been changed.",
                AC14: "The suite/apartment number has been changed.",
                AC20: "The street address number has been changed.",
                AE01: "The provided " + postalCode + " code is not valid.",
                AE02: "The provided street could not be matched to a unique street name.",
                AE03: "The combination of street direction (N, E, SW, etc.) and street type (AVE, ST, etc.) is not correct.",
                AE04: "The address provided must be a valid address to which mail can be delivered.",
                AE05: "The information provided matches more than one address.",
                AE06: "The address cannot currently be verified, but is identified as a possible future address.",
                AE07: "The address must have at least one address line and the " + postalCode + " code, or the city and " + state + ", to be validated.",
                AE08: "The street address has been found but the suite/apartment number is invalid.",
                AE09: "The street address has been found but the suite/apartment number is missing.",
                AE10: "The number for the street address is not valid.",
                AE11: "The number for the street address is missing.",
                AE12: "The PO, Rural Route, or Highway Contract Box number is invalid.",
                AE13: "The PO, Rural Route, or Highway Contract Box number is missing.",
                AE14: "The address is a Commercial Mail Receiving Agency and the Private Mail Box number is missing.",
                AE17: "The provided suite/apartment number is not valid for the street address."
            };
        }
    }


    angular.module("app").controller(CfncSelectAddressModal.controllerId, ["$uibModalInstance", "common", "$scope", "model", "addressService",
        ($uibModalInstance: ng.ui.bootstrap.IModalServiceInstance,
            common: ICommonFactory,
            $scope: ICfncSelectAddressModalScope,
        model: any,
        addressService: IAddressService) =>
            new CfncSelectAddressModal($uibModalInstance, common, $scope, model, addressService)
    ]);
}
